module.exports = __webpack_public_path__ + "static/media/ONE.5bad8bb1.png";